export default __webpack_public_path__ + "static/Card13-309f9aa63488485e5e0e9f8d61c9868a.png";